import React, { useState, useEffect } from 'react'
import { Table, Button, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import axios from 'axios'
import * as XLSX from 'xlsx'
import { getRejectedSTudentList } from '../../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'

const RejectedStudentList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')
  const adminId = sessionStorage.getItem('admin_id')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchingRejectedStudentList()
  }, [])

  const fetchingRejectedStudentList = async () => {
    setLoading(true)

    try {
      const res = await axios.get(
        `${getRejectedSTudentList}/${storedBranchId}/${BoardingYear}`,
      )

      const sortedData = res.data.sort(
        (a, b) => new Date(b.register_pay_date) - new Date(a.register_pay_date)
      );

      const formatted = sortedData.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: item.student_name,
        whats_no: item.wh_mobile || '-',
        tax_id: item?.register_tax_id ?? '-',
        pay_date: item?.register_pay_date?.split('T')[0] ?? '-',
        register_pay_mode:
          item.register_pay_mode === 1
            ? 'Cash'
            : item.register_pay_mode === 2
            ? 'UPI'
            : 'Online',
        payment_img: item?.register_tax_image ?? '',
        reason: item?.reason ?? '-',
        userName: item?.admin?.username ?? '-',
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load rejected list')
    } finally {
      setLoading(false)
    }
  }

  // Search
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search) ||
      (item.tax_id ?? '').toLowerCase().includes(search)
    )
  })

  // Export Excel
  const exportToExcel = () => {
    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Full Name': item.full_name,
      'WhatsApp No': item.whats_no,
      'Tax ID': item.tax_id,
      'Pay Date': item.pay_date,
      'Pay Mode': item.register_pay_mode,
      Reason: item.reason,
      Admin: item.userName,
    }))

    const worksheet = XLSX.utils.json_to_sheet(excelData)

    // Auto column widths
    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 30 },
      { wch: 18 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 35 },
      { wch: 20 },
    ]

    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Rejected Students')

    XLSX.writeFile(
      workbook,
      `Rejected_Student_List.xlsx`,
    )
  }

  const columns = [
    {
      title: 'Sr No',
      dataIndex: 'index',
      width: 80,
    },
    {
      title: 'Full Name',
      dataIndex: 'full_name',
    },
    {
      title: 'WhatsApp No',
      dataIndex: 'whats_no',
    },
    {
      title: 'Tax ID',
      dataIndex: 'tax_id',
    },
    {
      title: 'Pay Date',
      dataIndex: 'pay_date',
    },
    {
      title: 'Pay Mode',
      dataIndex: 'register_pay_mode',
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
    },
    {
      title: 'Admin',
      dataIndex: 'userName',
    },
  ]

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>

        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Rejected Student List</h2>
          </div>

          {/* Export + Search */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>

            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>

        <div className="col-12 col-md-2"></div>
      </div>
    </div>
  )
}

export default RejectedStudentList
